export default __webpack_public_path__ + "static/AppBeers7-76725a31e967517e9dab784dd22bd89b.png";